import { render } from "./PitchChart.vue?vue&type=template&id=c3e0f534"
import script from "./PitchChart.vue?vue&type=script&lang=js"
export * from "./PitchChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__